import * as React from 'react'
import * as Tooltip from 'react-tooltip'
import Select from 'react-select'

import { PaymentTypeIds, convertPaymentTypeIdToName } from '@getgreenline/homi-shared'
import { QuickBooksModels } from '@getgreenline/quickbooks'
interface IStringOption {
  value: string
  label: string
}
interface IProps {
  paymentType: QuickBooksModels.IQuickBooksPaymentTypesToSync
  options: IStringOption[]
  onSave: (
    paymentTypeId: PaymentTypeIds,
    debitAccountId: string | null,
    creditAccountId: string | null,
  ) => void
}

interface State {
  creditAccountId: string | null
  debitAccountId: string | null
}

export class PaymentTypeAccountSelector extends React.Component<IProps, State> {
  constructor(props: IProps) {
    super(props)
    const { paymentType } = props

    this.state = {
      creditAccountId: paymentType.creditAccountId,
      debitAccountId: paymentType.debitAccountId,
    }
  }

  onAccountSelect = () => {
    const { onSave, paymentType } = this.props
    const { creditAccountId, debitAccountId } = this.state
    onSave(paymentType.paymentTypeId, debitAccountId, creditAccountId)
  }

  render() {
    const { paymentType, options } = this.props
    const { creditAccountId, debitAccountId } = this.state

    return (
      <tr>
        <td className='mr-2' style={{ width: 150 }}>
          {convertPaymentTypeIdToName(paymentType.paymentTypeId)}
          {((creditAccountId && !debitAccountId) || (!creditAccountId && debitAccountId)) && (
            <>
              <span
                className='fa fa-exclamation-triangle text-danger ml-2'
                data-tip
                data-for='account-sync-warning'
              />
              <Tooltip id='account-sync-warning' place='bottom' effect='solid'>
                <div>
                  For transactions to be synced for this payment type, both a credit and debit
                  account must be provided.
                </div>
              </Tooltip>
            </>
          )}
        </td>
        <td>
          <Select
            value={debitAccountId}
            clearable={true}
            placeholder={'Map debit account'}
            options={options}
            onChange={(option: IStringOption) => {
              const newDebitAccountId = option ? option.value : null
              this.setState(
                {
                  debitAccountId: newDebitAccountId,
                },
                this.onAccountSelect,
              )
            }}
          />
        </td>
        <td>
          <Select
            value={creditAccountId}
            clearable={true}
            placeholder={'Map credit account'}
            options={options}
            onChange={(option: IStringOption) => {
              const newCreditAccountId = option ? option.value : null
              this.setState(
                {
                  creditAccountId: newCreditAccountId,
                },
                this.onAccountSelect,
              )
            }}
          />
        </td>
      </tr>
    )
  }
}
